// extracted by mini-css-extract-plugin
export default {"coachTable":"qnAAor5ESNyex4_sDdWB"};